import { FC } from 'react';
import { SurveySubmissionsTraining } from 'containers/surveys';
import { SurveyResultsLayout } from 'pages/atoms';

const SurveyResultsSubmissionsTrainingPage: FC = () => {
  return (
    <SurveyResultsLayout>
      <SurveySubmissionsTraining />
    </SurveyResultsLayout>
  );
};

export default SurveyResultsSubmissionsTrainingPage;
